import PropTypes from 'prop-types';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';

const Item = styled.div`
    display: flex;
    user-select: none;
    padding: 0.5rem;
    margin: 0 0 0.5rem 0;
    align-items: flex-start;
    align-content: flex-start;
    line-height: 1.5;
    border-radius: 3px;
    background: #fff;
    border: 1px ${(props) => (props.isDragging ? 'dashed #000' : 'solid #ddd')};
`;

const Clone = styled(Item)`
    ~ div {
        transform: none !important;
    }
`;

const Tool = ({ item, index }) => {
    const { label, id } = item;

    return (
        <Draggable
            key={`tool-${id}`}
            draggableId={`tool-${id}`}
            index={index}
        >
            {(provided, snapshot) => (
                <>
                    <Item
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        isDragging={snapshot.isDragging}
                        style={provided.draggableProps.style}
                    >
                        {label}
                    </Item>
                    {snapshot.isDragging && (
                        <Clone>{label}</Clone>
                    )}
                </>
            )}
        </Draggable>
    );
};

export default Tool;

Tool.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
};
